module.exports = __webpack_public_path__ + "static/media/flags-intro.8358a7f6.mp4";